import { Component, OnInit } from '@angular/core';
import { ObjectId } from 'bson';

import { EventTypes, FieldKinds, SignatureRuleLogic } from '@site-mate/dashpivot-shared-library';
import { CompanyPlanTypes } from '@site-mate/sitemate-global-shared/lib';

import { AppType } from 'app/apps/app-control-type.model';
import { TemplateFieldBaseComponent } from 'app/form-fields/common/template/template-field-base.component';
import { EventsService } from 'app/shared/service/events/events.service';
import { TeamService } from 'app/shared/service/team.service';
import { environment } from 'environments/environment';

import { SignatureType } from './signature-type.model';

@Component({
  selector: 'cc-app-signature',
  templateUrl: 'app-signature.component.html',
  styleUrls: ['../../common/template/form-control.component.scss', './app-signature.component.scss'],
})
export class AppSignatureComponent extends TemplateFieldBaseComponent implements OnInit {
  appType = AppType;
  signatureTypeEnum = SignatureType;
  fieldKinds = FieldKinds;
  isAddLogicAvailable = false;

  constructor(private eventsService: EventsService, private readonly teamService: TeamService) {
    super();
  }

  get signatureType() {
    if (this.model.kind === FieldKinds.Signature && this.app.appType === AppType.workflow) {
      // NOTE: we were incorrectly setting the field kind = 'signature' for timeline templates
      // this extra check to confirm the it's a workflow template before allowing approval signature fields
      return SignatureType.ApprovalSignature;
    }
    return this.model.isManualSignature ? SignatureType.SignatureArrayManual : SignatureType.SignatureArray;
  }

  set signatureType(value: SignatureType) {
    if (value === SignatureType.ApprovalSignature) {
      this.model.kind = FieldKinds.Signature;
      this.model.isApprovalSignature = true;
    } else {
      this.model.kind = FieldKinds.SignatureArray;
      this.model.isManualSignature = value === SignatureType.SignatureArrayManual;
      this.model.isApprovalSignature = false;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();

    // NOTE: we were incorrectly setting the field kind = 'signature' for timeline templates, so need
    // this extra check to fix up the field kind. All other checks should come after it.
    if (this.model.kind === FieldKinds.Signature && this.app.appType !== AppType.workflow) {
      this.model.kind = FieldKinds.SignatureArray;
    }

    if (this.signatureType === this.signatureTypeEnum.ApprovalSignature) {
      this.model.isApprovalSignature = true;
    }

    this.isAddLogicAvailable = this.getAddLogicVisibility();
  }

  private getAddLogicVisibility(): boolean {
    if (this.model.isApprovalSignature && environment.featureToggles.approvalSignatureLogic) {
      const lowTierPlan = [
        CompanyPlanTypes.FreeTrial,
        CompanyPlanTypes.Legacy,
        CompanyPlanTypes.Standard,
      ].includes(this.teamService.getCurrentPlanType());
      return !lowTierPlan;
    }
    return false;
  }

  onAddLogic() {
    this.model.signatureRules = this.model.signatureRules || [];
    this.model.signatureRules.push({ _id: new ObjectId().toHexString() } as SignatureRuleLogic);
    this.updated.emit(this.model);

    this.eventsService.trackEvent(EventTypes.ApprovalSignatureLogicAdded);
  }

  approvalSignatureNumber() {
    const currentIndex = this.controls.indexOf(this.model);
    const approvalSignatureNum = this.controls.reduce(
      (signed, item, index) =>
        item.kind === FieldKinds.Signature && index <= currentIndex ? signed + 1 : signed,
      0,
    );
    return approvalSignatureNum;
  }
}
